<template>
	<div class="md-grey-page center-horizontal">

		<div v-if="loading">
			<section class="container-white">
				Deleting your account...
			</section>
		</div>

		<div v-if="!loading">
			<section class="container-white">
				<h1>Your personal information was successfully removed from our records.</h1>
				<p>
					You are seeing this message because you have requested the permanent removal of your personal information from the records of {{companyName}}.
				</p>
			</section>
		</div>

	</div>
</template>

<script>
import axios from 'axios';

export default {
  data: function() {
    return {
		 companyName: {},
		 loading: true
    }
  },
  created: async function() {
	  const that = this;

	  axios.delete(`${this.config.services.gdpr}/contact/${this.$route.params.companyId}/${this.$route.params.contactId}`)
	  .then(function(response) {
		  that.companyName = response.data.companyName;
		  that.loading = false;
	  })
	  .catch(function(error) {
		  console.error('error:', error);
	  });
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/GDPRRemove.vue